import { Declaration } from 'store/declarations/declaration';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';

const REPLACEABLE_STATUS_LABELS: Partial<Record<DeclarationStatuses, string>> = {
    [DeclarationStatuses.DRAFT]: 'DRAFT',
    [DeclarationStatuses.DECLARATION_REJECTED]: 'REJECTED',
    [DeclarationStatuses.DECLARATION_INVALIDATION]: 'INVALIDATED',
};

export const canReplaceMirroredDeclaration = (status: DeclarationStatuses) => status in REPLACEABLE_STATUS_LABELS;

export const getMirroredDeclarationExistsText = (status: DeclarationStatuses, messageType: string) => {
    const statusLabel = REPLACEABLE_STATUS_LABELS[status];

    if (!statusLabel) {
        return `A submitted ${messageType} already exists for this movement. Please amend or invalidate the existing declaration before generating a new one.`;
    }

    const consequence =
        status === DeclarationStatuses.DRAFT ? 'permanently delete it' : 'unlink it from the source declaration';

    return `An existing ${statusLabel} ${messageType} was found. Generating a new ${messageType} will ${consequence}. Do you want to generate a new ${messageType}?`;
};

export const canReplaceAllMirroredDeclarations = (declarations: Declaration[]) =>
    declarations.length > 0 && declarations.every((declaration) => canReplaceMirroredDeclaration(declaration.status));

export const getMultipleMirroredDeclarationsExistText = (declarations: Declaration[], messageType: string) => {
    const count = declarations.length;

    if (!canReplaceAllMirroredDeclarations(declarations)) {
        return `${count} ${messageType} declarations already exist for this movement and at least one has been submitted. Please amend or invalidate the submitted declarations before generating new ones.`;
    }

    return `${count} existing ${messageType} declarations were found for this movement. Generating new ones will delete the drafts and unlink the others from the source declaration. Do you want to generate new ${messageType} declarations?`;
};
